var _style, _g, _circle, _ellipse, _g2, _g3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1465 974",
    style: {
      enableBackground: "new 0 0 1465 974"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.8;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#FEFEFE;}\r\n\t.st3{fill:#FDFDFD;}\r\n\t.st4{fill:#FCFCFC;}\r\n\t.st5{fill:#FBFBFB;}\r\n\t.st6{fill:#FAFAFA;}\r\n\t.st7{fill:#F9F9F9;}\r\n\t.st8{fill:#F8F8F8;}\r\n\t.st9{fill:#F7F7F8;}\r\n\t.st10{fill:#F6F6F7;}\r\n\t.st11{fill:#F5F5F6;}\r\n\t.st12{fill:#F4F4F5;}\r\n\t.st13{fill:#F3F3F4;}\r\n\t.st14{fill:#F2F2F3;}\r\n\t.st15{fill:#F1F1F2;}\r\n\t.st16{fill:#F0F1F1;}\r\n\t.st17{fill:#EFF0F0;}\r\n\t.st18{fill:#EEEFEF;}\r\n\t.st19{fill:#EDEEEE;}\r\n\t.st20{fill:#ECEDED;}\r\n\t.st21{fill:#EBECEC;}\r\n\t.st22{fill:#EAEBEB;}\r\n\t.st23{fill:#E9EAEA;}\r\n\t.st24{fill:#E8E9EA;}\r\n\t.st25{fill:#E7E8E9;}\r\n\t.st26{fill:#E6E7E8;}\r\n\t.st27{fill:#E5E6E7;}\r\n\t.st28{fill:#E4E5E6;}\r\n\t.st29{fill:#E3E4E5;}\r\n\t.st30{fill:#E2E3E4;}\r\n\t.st31{fill:#E1E2E3;}\r\n\t.st32{fill:#E0E1E2;}\r\n\t.st33{fill:#DFE0E1;}\r\n\t.st34{fill:#DEDFE0;}\r\n\t.st35{fill:#DDDEDF;}\r\n\t.st36{fill:#DCDDDE;}\r\n\t.st37{fill:#DBDCDD;}\r\n\t.st38{fill:#DADBDC;}\r\n\t.st39{fill:#D9DADC;}\r\n\t.st40{fill:#D8D9DB;}\r\n\t.st41{fill:#D7D8DA;}\r\n\t.st42{fill:#D6D7D9;}\r\n\t.st43{fill:#D5D6D8;}\r\n\t.st44{fill:#D4D5D7;}\r\n\t.st45{fill:#D3D4D6;}\r\n\t.st46{fill:#D3D4D5;}\r\n\t.st47{fill:#D2D3D4;}\r\n\t.st48{fill:#D1D2D3;}\r\n\t.st49{fill:#D0D1D2;}\r\n\t.st50{fill:#CFD0D1;}\r\n\t.st51{fill:#CECFD0;}\r\n\t.st52{fill:#CDCECF;}\r\n\t.st53{fill:#CCCDCF;}\r\n\t.st54{fill:#CBCCCE;}\r\n\t.st55{fill:#CACBCD;}\r\n\t.st56{fill:#C9CACC;}\r\n\t.st57{fill:#C8C9CB;}\r\n\t.st58{fill:#C7C8CA;}\r\n\t.st59{fill:#C6C7C9;}\r\n\t.st60{fill:#C5C6C8;}\r\n\t.st61{fill:#C4C5C7;}\r\n\t.st62{fill:#C3C4C6;}\r\n\t.st63{fill:#C2C3C5;}\r\n\t.st64{fill:#C1C2C4;}\r\n\t.st65{fill:#C0C1C3;}\r\n\t.st66{fill:#BFC0C2;}\r\n\t.st67{fill:#BEBFC1;}\r\n\t.st68{fill:#BDBEC1;}\r\n\t.st69{fill:#BCBDC0;}\r\n\t.st70{fill:#BBBCBF;}\r\n\t.st71{fill:#BABBBE;}\r\n\t.st72{fill:#B9BABD;}\r\n\t.st73{fill:#B8B9BC;}\r\n\t.st74{fill:#B7B8BB;}\r\n\t.st75{fill:#B6B7BA;}\r\n\t.st76{fill:#B5B7B9;}\r\n\t.st77{fill:#B4B6B8;}\r\n\t.st78{fill:#B3B5B7;}\r\n\t.st79{fill:#B2B4B6;}\r\n\t.st80{fill:#B1B3B5;}\r\n\t.st81{fill:#B0B2B4;}\r\n\t.st82{fill:#AFB1B3;}\r\n\t.st83{fill:#AEB0B3;}\r\n\t.st84{fill:#ADAFB2;}\r\n\t.st85{fill:#ACAEB1;}\r\n\t.st86{fill:#ABADB0;}\r\n\t.st87{fill:#AAACAF;}\r\n\t.st88{fill:#A9ABAE;}\r\n\t.st89{fill:#A8AAAD;}\r\n\t.st90{fill:#A7A9AC;}\r\n\t.st91{fill:#E4E4E4;}\r\n\t.st92{fill:url(#SVGID_1_);}\r\n\t.st93{fill:#C6C5C4;}\r\n\t.st94{fill:#00B33F;}\r\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 754.2,
    cy: 508,
    r: 345
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 754,
    cy: 507.8,
    r: 344.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 753.7,
    cy: 507.5,
    r: 344.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 753.5,
    cy: 507.3,
    r: 344.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 753.2,
    cy: 507.1,
    r: 344
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 753,
    cy: 506.9,
    r: 343.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 752.7,
    cy: 506.6,
    r: 343.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 752.4,
    cy: 506.4,
    r: 343.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 752.2,
    cy: 506.2,
    r: 342.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 751.9,
    cy: 506,
    r: 342.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 751.7,
    cy: 505.7,
    r: 342.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 751.4,
    cy: 505.5,
    r: 342.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 751.2,
    cy: 505.3,
    r: 341.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 750.9,
    cy: 505.1,
    r: 341.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 750.6,
    cy: 504.8,
    r: 341.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 750.4,
    cy: 504.6,
    r: 341.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 750.1,
    cy: 504.4,
    r: 340.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 749.9,
    cy: 504.2,
    r: 340.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 749.6,
    cy: 503.9,
    r: 340.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st20",
    cx: 749.4,
    cy: 503.7,
    r: 340
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st21",
    cx: 749.1,
    cy: 503.5,
    r: 339.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 748.8,
    cy: 503.3,
    r: 339.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st23",
    cx: 748.6,
    cy: 503,
    r: 339.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st24",
    cx: 748.3,
    cy: 502.8,
    r: 339
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st25",
    cx: 748.1,
    cy: 502.6,
    r: 338.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st26",
    cx: 747.8,
    cy: 502.4,
    r: 338.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 747.6,
    cy: 502.1,
    r: 338.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st28",
    cx: 747.3,
    cy: 501.9,
    r: 338
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st29",
    cx: 747,
    cy: 501.7,
    r: 337.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st30",
    cx: 746.8,
    cy: 501.4,
    r: 337.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st31",
    cx: 746.5,
    cy: 501.2,
    r: 337.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st32",
    cx: 746.3,
    cy: 501,
    r: 336.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st33",
    cx: 746,
    cy: 500.8,
    r: 336.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st34",
    cx: 745.8,
    cy: 500.5,
    r: 336.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st35",
    cx: 745.5,
    cy: 500.3,
    r: 336.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st36",
    cx: 745.2,
    cy: 500.1,
    r: 335.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st37",
    cx: 745,
    cy: 499.9,
    r: 335.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st38",
    cx: 744.7,
    cy: 499.6,
    r: 335.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st39",
    cx: 744.5,
    cy: 499.4,
    r: 335.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 744.2,
    cy: 499.2,
    r: 334.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st41",
    cx: 744,
    cy: 499,
    r: 334.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 743.7,
    cy: 498.7,
    r: 334.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st43",
    cx: 743.4,
    cy: 498.5,
    r: 334
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st44",
    cx: 743.2,
    cy: 498.3,
    r: 333.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st45",
    cx: 742.9,
    cy: 498.1,
    r: 333.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st46",
    cx: 742.7,
    cy: 497.8,
    r: 333.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st47",
    cx: 742.4,
    cy: 497.6,
    r: 333
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st48",
    cx: 742.2,
    cy: 497.4,
    r: 332.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st49",
    cx: 741.9,
    cy: 497.2,
    r: 332.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st50",
    cx: 741.6,
    cy: 496.9,
    r: 332.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st51",
    cx: 741.4,
    cy: 496.7,
    r: 332
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st52",
    cx: 741.1,
    cy: 496.5,
    r: 331.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st53",
    cx: 740.9,
    cy: 496.3,
    r: 331.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st54",
    cx: 740.6,
    cy: 496,
    r: 331.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st55",
    cx: 740.4,
    cy: 495.8,
    r: 330.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st56",
    cx: 740.1,
    cy: 495.6,
    r: 330.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st57",
    cx: 739.8,
    cy: 495.3,
    r: 330.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st58",
    cx: 739.6,
    cy: 495.1,
    r: 330.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st59",
    cx: 739.3,
    cy: 494.9,
    r: 329.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 739.1,
    cy: 494.7,
    r: 329.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st61",
    cx: 738.8,
    cy: 494.4,
    r: 329.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st62",
    cx: 738.6,
    cy: 494.2,
    r: 329.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st63",
    cx: 738.3,
    cy: 494,
    r: 328.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st64",
    cx: 738,
    cy: 493.8,
    r: 328.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st65",
    cx: 737.8,
    cy: 493.5,
    r: 328.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st66",
    cx: 737.5,
    cy: 493.3,
    r: 328.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st67",
    cx: 737.3,
    cy: 493.1,
    r: 327.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st68",
    cx: 737,
    cy: 492.9,
    r: 327.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st69",
    cx: 736.8,
    cy: 492.6,
    r: 327.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st70",
    cx: 736.5,
    cy: 492.4,
    r: 327
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st71",
    cx: 736.2,
    cy: 492.2,
    r: 326.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st72",
    cx: 736,
    cy: 492,
    r: 326.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st73",
    cx: 735.7,
    cy: 491.7,
    r: 326.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st74",
    cx: 735.5,
    cy: 491.5,
    r: 326
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st75",
    cx: 735.2,
    cy: 491.3,
    r: 325.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st76",
    cx: 735,
    cy: 491.1,
    r: 325.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st77",
    cx: 734.7,
    cy: 490.8,
    r: 325.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st78",
    cx: 734.4,
    cy: 490.6,
    r: 324.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st79",
    cx: 734.2,
    cy: 490.4,
    r: 324.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st80",
    cx: 733.9,
    cy: 490.2,
    r: 324.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st81",
    cx: 733.7,
    cy: 489.9,
    r: 324.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st82",
    cx: 733.4,
    cy: 489.7,
    r: 323.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st83",
    cx: 733.2,
    cy: 489.5,
    r: 323.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st84",
    cx: 732.9,
    cy: 489.2,
    r: 323.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st85",
    cx: 732.6,
    cy: 489,
    r: 323.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st86",
    cx: 732.4,
    cy: 488.8,
    r: 322.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st87",
    cx: 732.1,
    cy: 488.6,
    r: 322.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st88",
    cx: 731.9,
    cy: 488.3,
    r: 322.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st89",
    cx: 731.6,
    cy: 488.1,
    r: 322.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st90",
    cx: 731.4,
    cy: 487.9,
    r: 321.8
  }))), /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st91",
    cx: 731.4,
    cy: 487.9,
    r: 321.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 513.8211,
    y1: 270.3553,
    x2: 927.9595,
    y2: 684.4937
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7DDD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st92",
    cx: 731.4,
    cy: 487.9,
    rx: 308.6,
    ry: 308.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M862.8,344.8L662.7,545l-78-78c-5.3-5.3-13.8-5.3-19.1,0l-50.1,50.1c-5.3,5.3-5.3,13.8,0,19.1l137.7,137.7 c5.3,5.3,13.8,5.3,19.1,0L932,414c5.3-5.3,5.3-13.8,0-19.1l-50.1-50.1C876.6,339.5,868.1,339.5,862.8,344.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M862.8,355.4L662.7,555.6l-78-78c-5.3-5.3-13.8-5.3-19.1,0l-50.1,50.1c-5.3,5.3-5.3,13.8,0,19.1l137.7,137.7 c5.3,5.3,13.8,5.3,19.1,0L932,424.6c5.3-5.3,5.3-13.8,0-19.1l-50.1-50.1C876.6,350.1,868.1,350.1,862.8,355.4z"
  }))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M862.8,348.8L662.7,548.9L584.7,471c-5.3-5.3-13.9-5.3-19.2,0l-50,50c-5.3,5.3-5.3,13.9,0,19.2L653,677.8 c5.3,5.3,13.9,5.3,19.2,0L932,418.1c5.3-5.3,5.3-13.9,0-19.2l-50-50C876.7,343.5,868.1,343.5,862.8,348.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 413,
    height: 325,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZ0AAAFFCAYAAAA3sjDgAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAEHZJREFUeNrs3VmPHNd5gGFyAHHV wl1SLN8n+buSLWrf7CAwDBtxgtzYgO9sBBBFyQHEXRJtBTO9TO/brJU+1WyalEVyZth1uk/V8wCN GkkESFbVnLe/U6OZY8cAWJrf/+GPWbC+vpE1ms3svQ8+ypwVABbqzt172dyj/77b7WXj8Tj7/Np1 8QHg+YSYhKnmh7H5oZ2dnfzXvfmzq+IDwNGCs7+/n78O8utDdDY2asIDQLHBmQvRCa+3fv6O8ABQ XHAeC0+tLjwAFBuch+GZRqc2ff3s7XeFB4DigjMXolOrN4QHgGKD8zA80+jUp6+fX31PeAAoLjhz ITr1hvAACE7BwXkYnml0Go1m9vY7wgNQ2eDs7e0VHpy5EJ3wrXPefud94QGoYnDCK+bvG6LTbG5m V4UHQHBiCNFpbk7D8+4HwgMgOBHCM43O5mZLeAAEJ44Qnc1WK3vnvQ+FB0BwIoRnGp1Wqy08AIIT R4hOeL37vh8IByA4kcLTbgsPgOBEEqLTbney9z74WHgAUgvO7m46wfl7eDpZpyM8AIkFZzePTop/ /hCdTqebvf+h8AAkEpzdpBfsEJ1ON4TnE+EBEJwI4ZlGp9vtZR98JDwAghNBiE63F8LzqfAACE6E 8Eyj0+v1sw+FB0BwYgjR6fWn4fn4M+EBEJwI4ZlGp98fZB8JD0D84OxUKDhzITr9wTQ8n/xCeACi BWdnN49OFf/+ITqD6etj4QGIEZydPDpVPg+DPDzD7ONPfyk8AMUGZ8dCm4dnmA2HwgMgOJGE6AyH o+yTz4QHQHCihGeUjUYhPP/m/AAITvFCdEajcfbpL4QHQHCihGecjcfj7M23rjpfAIJTvBCd8Xgi PACHCc624DxHeCbZZCI8AAcLzvZOHh1n4+hCdIQH4JnB2c6j42wsJjxbW1vCA/Dk4GxbIBcoREd4 AAQnbnim51Z4AMERnDjheXCOhQcQHMGJYv68THgAwSFSeGZfii48gOAQxfxHQwgPUIngbG0JzvLD M/upq8IDlD444eVsLN/urvAApQ7OluCsYHj29vaEByhjcLYsbCsoREd4AMEhangC4QEEhyiyB4QH EByihWd9fcM1AwSHOGq1evbb//hP1w5IIzgTwUlev993/YAEgjPZyqPjbIgOQPHBmQhOGYwnE892 gFUOzkRwSkZ0gBUOzsQCVSLtdju7eeu2awoIDsUbDAauKSA4iA4gOJTI3t5+9tkv/921BQSHYvmO BMBKBWcsOKUOTuBMAKsRnPEkj46zITgAxQdnLDiCA1B4cMaCIzgAsYIztigJDoDgIDiA4CA4AIIj OIIDCA6CA1QtOCPBERyAKMEZjfPoOBuCA1B8cEaCIzgAgoPgAOUIzkhwBAcgVnBGFiXBARAcBAcQ HAQH4GDBGQqO4ADECs5QcAQHoPDgDAVHcABiBWcoOIIDIDgIDlCO4AwFR3AAYgVnaFESHADB4fmC 8+ZbV11fQHAQHKAiwRkIjuAAxArOQHAEB6Dw4AwER3AAYgVnIDiCAyA4CA5QjuAMBEdwAGIFZ2BB EhwAwUFwAMFBcAAOFpy+4AgOQJTg9Ad5dJwNwQEoPjh9wREcAMFBcADBQXAADhycvuAIDkCs4PQt SIIDIDgIDlCC4PQER3AAYgWnJziCA1Ckr/7yv1mvJziCAxArOD3BERyAIoPzleAIDoDgIDhAuYLT E5ySB8eZAJbuy4fB6VmUBAdAcBAcoATB6QqO4ADECk5XcAQHoPDgdAVHcABiBacrOIIDIDgIDiA4 CA6A4AiO4JTXr379m/zirq9vZH/68/+4yCQSnK7gCA4puXvvm+xRj17sECBniNUOTtc9Kjik4Osb N/OoPO3Cbm9v579GfFi14HQER3BIKziHubB5eDZqbgJWIDh/yYPTERzBoZzBeRieaXQ2hIdlB6cj OIJD6YMztyE8LDs4HcERHCoRnMfCUxMeBAfBoeDgPAxPLYSn7iZBcBAcig3O38NTz2rCg+AgOBQd nLma8FBUcL4MwekIjuAgOD8SnrrwsNjgtPPgdNxXgoPg/Eh4ptGp1xtuIp7b9QfBaQuO4CA4TxOi IzwIDoIjOMJDGsFpC47gIDhHCU9DeDhCcNqCIzgIzlHCM41Oo9F0kyE4giM4ghNHiI7wIDiC40wI TtzwNIUHwREcBCdWeKbRaTY33Xz8IDhtwREcUnH/r3/LUrqwITrCwzw4rTw4bfeD4JBEcO7/NUvx wgoP8+C0BEdwSMN3iQbnsfBsCo/gIDgITqzwTKOzudlyc1YtOC3BERzSCc5397MyXdgQHeGpWHBa giM4JOHbkgXnsfC0hEdwEBwEJ1Z4WsJT3uB8JTiCQ1LB+fa7rAoXNkTHwiQ4CA5L9E1FgjNngSpb cLyREBwEJ4Xw+Oqm5IMzm1xtmQoOaQTnm2+zKl/Ylm+NknxwPKMTHBJxr+LBmfNNIBMMzvWvMl+N KDgIjvAQLzj+vyvBIZHg3BOcJ4bHjy5eaV8IjuCQlrv3vhGcp4VnGp1Op+vcCA6Cg+DEEaIjPIKD 4PA8wbkrOIcOT1d4BAfB4dDu3L0nOEcJzzQ6XeFZenB8l3DBQXAqo5uHp+fcLTE4fh6S4JBKcO4I zmLC0xMewUFweJrbd+4KzqLD0xOeaMHxE18FB8GpfHim0ekJT5zgNAVHcEgjOLcFp0i9PDx951Zw EBxu3b4jOFHC0896feERHARHcFzYWOGZRqcvPIKD4FQyOLcEZxn6eXgGzrngIDjVcfPWbcFZangG wvMcwWk0m4IjOAgOhw7PQHgOF5wv8+CEl7MhOKQQnJuCs1LhmUZnIDyCg+CU0Y2btwRnBQ3y8Axd k2cFpyE4goPgsKDwDLPBUHieGpyG4AgOaQTnhuAkEZ5pdIbC83hwvhAcwSEpX9+4KTgJGQqP4AgO iVmbf/D7P/wxO3/uXP7x8SmnZvWdPXv2+Cw+o0p/Ml6bBuenP30j//jy5Uvu3RIGx7pUQltbW9n+ /r53EklOPKNsOKpmeK6ZcEw4pOfNt676UtzUwzONzqhi4QnBqQuO4JCedrvjwpbAKA/PuBLXchac Rh4dV15wSEf+TGdnZ8eZKIEzZ84cn8Wn3OGZPcP5Sf7xFc9wShmccPQMp6TRCVtre3t7zkRpwnM6 /0Qdj8sZnjw4b8yDc9miJDikaBodY2zJhOiULTz5llq9kb9c4XIGx5ZaRUwmExe6tOEpx7UVHMGh HPJnOr/7r/8+5oeFlc/p0w+22hJ/U/HYltoVW2plDE442lKrmFarndVqdeEp48QzjU6q7yJNOCYc SjjpBN9+d9/ZKOvEc+rU8UffUaYUnDdMOCYcyit8RwLflcC7ylUJTm063dRMOO5FhAef7MUHpy44 7kGEB5/0sYLj+aJ7D+HBJ3/RwakJjnsO4cEiUHhwrs+C4yso3WsIj+9YYDEQHASHaEJ0hMeiIDgI DsJDsouD4LinQHgsElGu77Vr17MNwXEvgfBYLIpeLD5/EJwNwXEPgfBQ5KIxC05NcNw7cPjw7O7u urksHkcITs19456BwwvRER6LyIGDsyE47hUQHgpeTB4GZ0Nw3CMgPBS4qAiOewOEhyiLi+C4J6Dw 8OwIj0VGcNwLEEuIzs7OjpuxwotNCM664AgORAvPNDrCU81FZx6cdcERHBAeilx8ZsHZEBzBAeGh 2EUoD876Rh4dZ0Zw4EmOxwhPOL7wwgvHne5yLkbXvvjy2E/+6fX8n19//TXXuYTXOF8sppwNkpl4 tk08pZVPOOsmHBMOrJAQne1t4QHBocrWYv1GJx5sr21vb7uJIYHghKMtNZKNTh6eE8IDggORhegI D6xmcGypITyA4MAiwrMlPCA4VMbaMn/zEydO5HvGW1vCA8sMTjh6hkPpoxOcfBieLeEBwUF0IoTn pPCA4EBkITrCA3GC4xkOCA8IDiwjPJOJ8IDgUDZrq/iHOnnyZL7HLDyw2OCEo2c48AQhOpPJRHjA hINJp3inTs0nHuEBEw5Em3gmJh4w4YDwgOBAicMzHgsPCA6pWkvpD3vq1Kl8T1p44OnBCUfPcGBB QnTG47HwgAkHk07xTp+eTzzCAyYciDbxjE08YMKBuOEZCQ+C43OAJKyl/hc4ffp0vpUwGgkP1QxO ONpSQ3QiOiM8CA4QW4jOaDQSHioRHFtqmHSWPfGcmU88woMJB4g28YxMPJhwgLjhGQoPggMrZa2s f7EzZ87kWw/DofBQjuCEoy01RGeFnRUeBAeILURnOBwKD0kGx5YaJp3UJp6z84lHeDDhANEmnqGJ BxMOEDc8A+FBcGAp1qr2Fz579my+VTEYCA+rGZxwtKWG6JTIi8KD4ACxhegID6sSHFtqUJnwDHyy IzgQwVrVT8CLL8632oSH5QQnHG2pQeUmnkHWFx5MOGDSiTPxvJi/0+z3hQcTDohOBC8JD4IDxBai IzwUFRxbasATwtO3OCA4sEC2157gpZfmW23Cw2KCE4621IBnTDz9rCc8mHDApBNn4nkpf2fa6wkP JhwQnQheFh4EB4gtREd4OGhwbKkBCwpPz2KC4MAR2F47pJdfnm+1CQ8/HpxwtKUGLHji6WVd4cGE AyadOBPPy/k72W5XeDDhgOhE8IrwIDhAbCE6wlPd4NhSA5YUnq7FR3CAp7C9tiCvvDLbausIT2WC E4621EB0lhieV4RHcADiCtHpdISnrMGxpQYmnZVybj7xCI8JByDaxNMx8ZhwAKKHp2OxEhzgmO21 wp07N9tqawtPssEJR1tqIDoJheec8AgOQFwhOu228KQSHFtqYNJJ2vn5xCM8JhyAaBNP28RjwgGI Hp62xU1woFJsry3J+fOzrbaW8KxMcMLRlhqITonDc154BAcgrhCdVkt4lhUcW2pg0qmUC/OJR3hM OADRJp6WiceEAyA8ggNQ5vBstloWRcGB0vFMZwVduDB7xiM8iw9OOHqGA/AjQnQ2N4XHhAMmHSK4 eOHCbOIRHhMOQLSJZ9PEY8IBEB7BAShzeJqbmxZRwYFkeaaTkIsXZ894hOfZwQlHz3AAFiBEp9kU HhMOmHSI4NLFi7OJR3hMOADRJp6miceEAyA8ggNQ5vA0ms1KLrqCA2nxTKcELl2aPeOpWng8wwFY ohCdRqMa4THhgEmHJbt86dJs4il5eEw4AKs08TTKO/GYcABWNDz1koVHcCB9ttdK6vLl2VZbvdEo xSJtSw1EhxV3pSThERyAhITo1OtphseWGph0SG7iuTybeBILjwkHIOWJp57OxGPCAShJeGorHh7B gfKyvVYxV67Mttpq9fpKLuq21EB0KJlXVzQ8ggNQYiE6tdpqhMeWGph0KP3Ec2U28Sw5PCYcgCpN PLXlTTwmHICKhmcjcngEB6rH9hq5V1+dbbVt1GpRImBLDUSHinttHp6NYsMjOCA68CA8rxYaHsEB 4B+E6Cw6PJ7hABAlPIIDwIHCs/6c4REcYM4zHZ7qtddmz3iOGh7PcAA4tBCd9fWNQ4XHhAOYdDiS 1+cTzwHDY8IB4Ll9feNmPvFsb29nT4pN+O/7+/smHMCkw/P513/55+P3//Z9/nF/MMg2W608MI9u pXW7vWNra2smHAAW6ze//V32/ff/l31+7brJBnim/xdgADOAR3GaQAbGAAAAAElFTkSuQmCC",
    transform: "matrix(1 0 0 1 517 351)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.782df7b7a166c7fd7bd6bca687ff1d4b.svg";
export { ForwardRef as ReactComponent };